
function Header({ showForm, setShowForm }) {
    return (
        <header className="header">
            <div className="logo">
                <a href="/"><img src="logo.png" alt="Today I Learned logo"></img></a>
                <h1 className="application-name">Today I Learned</h1>
            </div>
            <div className="" >
                <button id="form-button" 
                    className="btn btn-large btn-mixed-colors"
                    onClick={()=>setShowForm((showForm) => !showForm)}
                >
                    {showForm ? "Close" : "Share a fact"} 
                </button>
            </div>
        </header>

        // <header className="header">
        //     <div className="logo" style={"justify-content: start;"}>
        //         <a href="/"><img src="logo.png" alt="Today I Learned logo"></img></a>
        //         <h1>Today I Learned</h1>
        //     </div>
        // <div className="" style={"justify-content: end;"} >
        //         <button id="form-button" className="btn btn-large btn-mixed-colors">Share a fact</button>
        //     </div>
        // </header>
    );
}

export default Header;
  